module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "con"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#con"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIP")]), _vm._v(" S. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDER")]), _c('br'), _vm._v("Professor of Post-Biblical Literature"), _c('br'), _vm._v("Co-Director, Center for Jewish Studies"), _c('br'), _vm._v("University of Manchester"), _c('br'), _vm._v("Manchester, England"), _c('br'), _c('i', [_vm._v("3 Maccabees")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBORAH")]), _vm._v(" A. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPLER")]), _c('br'), _vm._v("Assistant Professor of Old Testament"), _c('br'), _vm._v("Moravian Theological Seminary"), _c('br'), _vm._v("Bethlehem, Pennsylvania"), _c('br'), _c('i', [_vm._v("Syro-Palestinian and Biblical Archeology")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAEME")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULD")]), _c('br'), _vm._v("Professor of Hebrew Bible"), _c('br'), _vm._v("University of Edinburgh"), _c('br'), _vm._v("Edinburgh, Scotland"), _c('br'), _c('i', [_vm._v("1 and 2 Samuel")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" L. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALCH")]), _c('br'), _vm._v("Professor of New Testament"), _c('br'), _vm._v("Interim Director of Ph.D. Studies"), _c('br'), _vm._v("Brite Divinity School"), _c('br'), _vm._v("Texas Christian University"), _c('br'), _vm._v("Fort Worth, Texas"), _c('br'), _c('i', [_vm._v("Luke")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARCLAY")]), _c('br'), _vm._v("Lightfoot Professor of Divinity"), _c('br'), _vm._v("University of Durham"), _c('br'), _vm._v("Durham, England"), _c('br'), _c('i', [_vm._v("2 Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARGARET")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKER")]), _c('br'), _vm._v("Independent Scholar"), _c('br'), _vm._v("Former President of the Society for Old Testament Study"), _c('br'), _vm._v("Derbyshire, England"), _c('br'), _c('i', [_vm._v("Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" R. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTLETT")]), _c('br'), _vm._v("Fellow Emeritus"), _c('br'), _vm._v("Trinity College"), _c('br'), _vm._v("Dublin, Republic of Ireland"), _c('br'), _c('i', [_vm._v("1 and 2 Maccabees")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEPHEN")]), _vm._v(" C. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTON")]), _c('br'), _vm._v("Reader in New Testament"), _c('br'), _vm._v("Department of Theology"), _c('br'), _vm._v("University of Durham"), _c('br'), _vm._v("Durham, England"), _c('br'), _c('i', [_vm._v("1 Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHARD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUCKHAM")]), _c('br'), _vm._v("Professor of New Testament and"), _c('br'), _vm._v("Bishop Wardlaw Professor"), _c('br'), _vm._v("St. Mary’s College"), _c('br'), _vm._v("University of St. Andrews"), _c('br'), _vm._v("St. Andrews, Scotland"), _c('br'), _c('i', [_vm._v("James")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULYE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDMEAD")]), _c('br'), _vm._v("Assistant Professor of Biblical Studies"), _c('br'), _vm._v("Department of Religion and Philosophy"), _c('br'), _vm._v("James Madison University"), _c('br'), _vm._v("Harrisonburg, Virginia"), _c('br'), _c('i', [_vm._v("Syro-Palestinian and Biblical Archeology")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIP")]), _vm._v(" J. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDD")]), _c('br'), _vm._v("Formerly Senior Lecturer"), _c('br'), _vm._v("The Westminster Institute of Education"), _c('br'), _vm._v("Oxford Brookes University"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("M. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANIEL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARROLL")]), _vm._v(" R. (R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODAS")]), _vm._v(")"), _c('br'), _vm._v("Professor of Old Testament"), _c('br'), _vm._v("Denver Seminary"), _c('br'), _vm._v("Denver, Colorado"), _c('br'), _vm._v("Adjunct Professor of Old Testament"), _c('br'), _vm._v("Seminario Teológico Centroamericano"), _c('br'), _vm._v("Guatemala City, Guatemala"), _c('br'), _c('i', [_vm._v("Amos")]), _vm._v(" and "), _c('i', [_vm._v("Malachi")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONALD")]), _vm._v(" E. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENTS")]), _c('br'), _vm._v("Emeritus Professor of Old Testament Studies"), _c('br'), _vm._v("King’s College"), _c('br'), _vm._v("University of London"), _c('br'), _vm._v("London, England"), _c('br'), _c('i', [_vm._v("Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" J. A. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LINES")]), _c('br'), _vm._v("Research Professor"), _c('br'), _vm._v("Department of Biblical Studies"), _c('br'), _vm._v("University of Sheffield"), _c('br'), _vm._v("Sheffield, England"), _c('br'), _c('i', [_vm._v("Lamentations")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHARD")]), _vm._v(" J. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OGGINS")]), _c('br'), _vm._v("Formerly Senior Lecturer in Old Testament Studies"), _c('br'), _vm._v("King’s College"), _c('br'), _vm._v("University of London"), _c('br'), _vm._v("London, England"), _c('br'), _c('i', [_vm._v("1 and 2 Chronicles")])])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "ConSb"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDNIE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HITE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAWFORD")]), _c('br'), _vm._v("Professor of Hebrew and"), _c('br'), _vm._v("Chair, Classics and Religious Studies"), _c('br'), _vm._v("University of Nebraska-Lincoln"), _c('br'), _vm._v("Lincoln, Nebraska"), _c('br'), _c('i', [_vm._v("Esther")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIP")]), _vm._v(" R. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVIES")]), _c('br'), _vm._v("Professor of Biblical Studies"), _c('br'), _vm._v("University of Sheffield"), _c('br'), _vm._v("Sheffield, England"), _c('br'), _c('i', [_vm._v("Prayer of Manasseh")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHARINE")]), _vm._v(" J. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELL")]), _c('br'), _vm._v("Senior Lecturer"), _c('br'), _vm._v("University of Cambridge and"), _c('br'), _vm._v("Fellow"), _c('br'), _vm._v("St. Catharine’s College"), _c('br'), _vm._v("Cambridge, England"), _c('br'), _c('i', [_vm._v("Job")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" A. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("DE")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILVA")]), _c('br'), _vm._v("Professor of New Testament and Greek"), _c('br'), _vm._v("Ashland Theological Seminary"), _c('br'), _vm._v("Ashland, Ohio"), _c('br'), _c('i', [_vm._v("4 Maccabees")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("A. R. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IAMOND")]), _c('br'), _vm._v("Educational Consultant"), _c('br'), _vm._v("Santa Barbara, California"), _c('br'), _c('i', [_vm._v("Jeremiah")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(" D. G. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNN")]), _c('br'), _vm._v("Lightfoot Professor Emeritus of Divinity"), _c('br'), _vm._v("University of Durham"), _c('br'), _vm._v("Durham, England"), _c('br'), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _c('br'), _c('i', [_vm._v("Preface")]), _vm._v(" and "), _c('i', [_vm._v("The History of the Tradition: New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE")]), _vm._v(" I. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MMERSON")]), _c('br'), _vm._v("Visiting Lecturer in Theology"), _c('br'), _vm._v("University of Birmingham"), _c('br'), _vm._v("Birmingham, England"), _c('br'), _c('i', [_vm._v("Hosea")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAIG")]), _vm._v(" A. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VANS")]), _c('br'), _vm._v("Payzant Professor of New Testament"), _c('br'), _vm._v("Acadia Divinity School"), _c('br'), _vm._v("Wolfville, Nova Scotia, Canada"), _c('br'), _c('i', [_vm._v("Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OEL")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEDMAN")]), _c('br'), _vm._v("Endowed Chair for Hebrew Biblical Studies"), _c('br'), _vm._v("University of California, San Diego"), _c('br'), _vm._v("La Jolla, California"), _c('br'), _c('i', [_vm._v("The Pentateuch")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICTOR")]), _vm._v(" P. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URNISH")]), _c('br'), _vm._v("University Distinguished Professor Emeritus of New Testament"), _c('br'), _vm._v("Perkins School of Theology"), _c('br'), _vm._v("Southern Methodist University"), _c('br'), _vm._v("Dallas, Texas"), _c('br'), _c('i', [_vm._v("Letters in the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVERLY")]), _vm._v(" R. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVENTA")]), _c('br'), _vm._v("Helen H. P. Manson Professor of New Testament Literature and Exegesis"), _c('br'), _vm._v("Princeton Theological Seminary"), _c('br'), _vm._v("Princeton, NewJersey"), _c('br'), _c('i', [_vm._v("Galatians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTHONY")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELSTON")]), _c('br'), _vm._v("Emeritus Reader in Theology"), _c('br'), _vm._v("University of Durham"), _c('br'), _vm._v("Durham, England"), _c('br'), _c('i', [_vm._v("Joel, Obadiah, Habakkuk")]), _vm._v(", and "), _c('i', [_vm._v("Zephaniah")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" A. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLDINGAY")]), _c('br'), _vm._v("David Allan Hubbard Professor of Old Testament"), _c('br'), _vm._v("Fuller Theological Seminary"), _c('br'), _vm._v("Pasadena, California"), _c('br'), _c('i', [_vm._v("Premodern, Modern, and Postmodern in Old Testament Study")]), _c('br'), _vm._v("and "), _c('i', [_vm._v("Ezekiel")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTER")]), _vm._v(" L. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RABBE")]), _c('br'), _vm._v("Professor of HebrewBible and Early Judaism"), _c('br'), _vm._v("University of Hull"), _c('br'), _vm._v("Hull, England"), _c('br'), _c('i', [_vm._v("Ezra, Nehemiah")]), _vm._v(", and "), _c('i', [_vm._v("Tobit")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OEL")]), _vm._v(" B. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEN")]), _c('br'), _vm._v("Dean of Academic Affairs and"), _c('br'), _vm._v("Professor of NewT estament Interpretation"), _c('br'), _vm._v("Asbury Theological Seminary"), _c('br'), _vm._v("Wilmore, Kentucky"), _c('br'), _c('i', [_vm._v("Hermeneutical Approaches to the New Testament Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("P. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERYN")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UEST")]), _c('br'), _vm._v("Lecturer in Biblical Hermeneutics"), _c('br'), _vm._v("University of Birmingham"), _c('br'), _vm._v("Birmingham, England"), _c('br'), _c('i', [_vm._v("Judges")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNN")]), _c('br'), _vm._v("A. A. Bradford Chair of Religion"), _c('br'), _vm._v("Texas Christian University"), _c('br'), _vm._v("Fort Worth, Texas"), _c('br'), _c('i', [_vm._v("Jonah")])])]), _c('p', {
    staticClass: "ConSb"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANIEL")]), _vm._v(" C. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLOW")]), _c('br'), _vm._v("Assistant Professor of Religion"), _c('br'), _vm._v("Calvin College"), _c('br'), _vm._v("Grand Rapids, Michigan"), _c('br'), _c('i', [_vm._v("The Hebrew Bible in the Dead Sea Scrolls")]), _vm._v(" and"), _c('br'), _c('i', [_vm._v("The Dead Sea Scrolls and the New Testament")])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "ConSb"
  }, [_vm._v("A. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYMAN")]), _c('br'), _vm._v("Senior Lecturer in Hebrew and Jewish Studies"), _c('br'), _vm._v("School of Divinity"), _c('br'), _vm._v("University of Edinburgh"), _c('br'), _vm._v("Edinburgh, Scotland"), _c('br'), _c('i', [_vm._v("Wisdom of Solomon")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNA")]), _vm._v(" D. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKER")]), _c('br'), _vm._v("Lady Margaret’s Professor of Divinity Emerita"), _c('br'), _vm._v("University of Cambridge"), _c('br'), _vm._v("Life Fellow"), _c('br'), _vm._v("Robinson College"), _c('br'), _vm._v("Cambridge, England"), _c('br'), _c('i', [_vm._v("Colossians")]), _vm._v(" and "), _c('i', [_vm._v("Philemon")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALTER")]), _vm._v(" J. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUSTON")]), _c('br'), _vm._v("Chaplain Fellow and Director of Ministerial Training"), _c('br'), _vm._v("Mansfield College"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("Leviticus")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARICK")]), _c('br'), _vm._v("Old Testament Tutor"), _c('br'), _vm._v("St. Stephen’s House"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("Ecclesiastes and Greek Esther")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EWETT")]), _c('br'), _vm._v("Guest Professor of New Testament"), _c('br'), _vm._v("University of Heidelberg"), _c('br'), _vm._v("Heidelberg, Germany"), _c('br'), _c('i', [_vm._v("1 and 2 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" D. J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHNSTONE")]), _c('br'), _vm._v("Professor Emeritus of Hebrew and Semitic Languages"), _c('br'), _vm._v("University of Aberdeen"), _c('br'), _vm._v("Aberdeen, Scotland"), _c('br'), _c('i', [_vm._v("Exodus")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("I. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWARD")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSHALL")]), _c('br'), _vm._v("Honorary Research Professor of New Testament"), _c('br'), _vm._v("University of Aberdeen"), _c('br'), _vm._v("Aberdeen, Scotland"), _c('br'), _c('i', [_vm._v("Ephesians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("COT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIGHT")]), _c('br'), _vm._v("Karl A. Olsson Professor in Religious Studies"), _c('br'), _vm._v("North Park Seminary"), _c('br'), _vm._v("Libertyville, Illinois"), _c('br'), _c('i', [_vm._v("2 Peter")]), _vm._v(" and "), _c('i', [_vm._v("Jude")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(" R. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UELLER")]), _c('br'), _vm._v("Associate Professor of Religion"), _c('br'), _vm._v("University of Florida"), _c('br'), _vm._v("Gainesville, Florida"), _c('br'), _c('i', [_vm._v("Introduction to the Pseudepigrapha")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANIEL")]), _vm._v(" C. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSON")]), _c('br'), _vm._v("Doctoral Student"), _c('br'), _vm._v("Graduate Theological Union"), _c('br'), _vm._v("Berkeley, California"), _c('br'), _c('i', [_vm._v("1 Enoch")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINTER")]), _c('br'), _vm._v("Professor of Theology"), _c('br'), _vm._v("St. Mark’s National Theological Centre"), _c('br'), _vm._v("Charles Sturt University, Canberra Campus"), _c('br'), _vm._v("Barton, Australian Capital Territory"), _c('br'), _c('i', [_vm._v("1, 2, and 3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEME")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERKINS")]), _c('br'), _vm._v("Professor of New Testament"), _c('br'), _vm._v("Boston College"), _c('br'), _vm._v("Boston, Massachusetts"), _c('br'), _c('i', [_vm._v("1 and 2 Timothy")]), _vm._v(" and "), _c('i', [_vm._v("Titus")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLEM")]), _vm._v(" S. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINSLOO")]), _vm._v(" ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("DECEASED")]), _vm._v(")"), _c('br'), _vm._v("Dean and Head of the Department of Old Testament Theology and Exegesis"), _c('br'), _vm._v("Faculty of Theology"), _c('br'), _vm._v("University of Pretoria, South Africa"), _c('br'), _c('i', [_vm._v("Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROVAN")]), _c('br'), _vm._v("Professor of Old Testament"), _c('br'), _vm._v("Regent College"), _c('br'), _vm._v("Vancouver, British Columbia"), _c('br'), _vm._v("Canada"), _c('br'), _c('i', [_vm._v("Daniel")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDDITT")]), _c('br'), _vm._v("Chair, Department of Religion"), _c('br'), _vm._v("Georgetown College"), _c('br'), _vm._v("Georgetown, Kentucky"), _c('br'), _c('i', [_vm._v("Introduction to Prophetic Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EUMANN")]), _c('br'), _vm._v("Ministerium of Pennsylvania and Professor Emeritus of New Testament"), _c('br'), _vm._v("Lutheran Theological College"), _c('br'), _vm._v("Philadelphia, Pennsylvania"), _c('br'), _c('i', [_vm._v("Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" W. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OGERSON")]), _c('br'), _vm._v("Professor Emeritus of Biblical Studies"), _c('br'), _vm._v("University of Sheffield"), _c('br'), _vm._v("Sheffield, England"), _c('br'), _vm._v("Editor of the Old Testament and Apocrypha"), _c('br'), _c('i', [_vm._v("Preface, The History of the Tradition: Old Testament and")]), _c('br'), _c('i', [_vm._v("Apocrypha, Deuteronomy, Song of Songs, Micah, Nahum")]), _vm._v(","), _c('br'), _c('i', [_vm._v("Haggai, Zechariah")]), _vm._v(", and "), _c('i', [_vm._v("Additions to Daniel")])])]), _c('p', {
    staticClass: "ConSb"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTHONY")]), _vm._v(" J. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALDARINI")]), _vm._v(" ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("DECEASED")]), _vm._v(")"), _c('br'), _vm._v("Professor of Theology"), _c('br'), _vm._v("Boston College"), _c('br'), _vm._v("Boston, Massachusetts"), _c('br'), _c('i', [_vm._v("Matthew")])])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "ConSb"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LISON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVESEN")]), _c('br'), _vm._v("Hebrew Centre Lecturer"), _c('br'), _vm._v("The Oriental Institute"), _c('br'), _vm._v("University of Oxford"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("Psalm 151")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" J. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHMITT")]), _c('br'), _vm._v("Associate Professor of Biblical Studies"), _c('br'), _vm._v("Marquette University"), _c('br'), _vm._v("Milwaukee, Wisconsin"), _c('br'), _c('i', [_vm._v("Baruch")]), _vm._v(" and "), _c('i', [_vm._v("2 Esdras")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN")]), _vm._v(" C. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("COTT")]), _c('br'), _vm._v("Senior Vocational Guidance Officer"), _c('br'), _vm._v("Board of Ministry"), _c('br'), _vm._v("Church of Scotland"), _c('br'), _vm._v("Edinburgh, Scotland"), _c('br'), _c('i', [_vm._v("John")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NAITH")]), _c('br'), _vm._v("Formerly Lecturer in Hebrew and Aramaic"), _c('br'), _vm._v("University of Cambridge"), _c('br'), _vm._v("Cambridge, England"), _c('br'), _c('i', [_vm._v("Sirach (Ecclesiasticus)")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" T. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUIRES")]), _c('br'), _vm._v("Academic Dean and Lecturer in Biblical Studies"), _c('br'), _vm._v("United Theological College"), _c('br'), _vm._v("School of Theology"), _c('br'), _vm._v("Charles Sturt University"), _c('br'), _vm._v("Australia"), _c('br'), _c('i', [_vm._v("Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAHAM")]), _vm._v(" N. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TANTON")]), _c('br'), _vm._v("Lady Margaret’s Professor of Divinity"), _c('br'), _vm._v("University of Cambridge"), _c('br'), _vm._v("Cambridge, England"), _c('br'), _c('i', [_vm._v("1 Peter")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREN")]), _vm._v(" T. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUCKENBRUCK")]), _c('br'), _vm._v("Professor of New Testament"), _c('br'), _vm._v("University of Durham"), _c('br'), _vm._v("Durham, England"), _c('br'), _c('i', [_vm._v("Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTHONY")]), _vm._v(" C. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HISELTON")]), _c('br'), _vm._v("Emeritus Professor of Christian Theology in Residence"), _c('br'), _vm._v("University of Nottingham, and"), _c('br'), _vm._v("Canon Theologian of Leicester Cathedral and of Southwell Minster"), _c('br'), _vm._v("Nottingham, England"), _c('br'), _c('i', [_vm._v("Hebrews")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OGER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMES")]), _c('br'), _vm._v("Honorary Research Fellow"), _c('br'), _vm._v("University of Manchester"), _c('br'), _vm._v("Manchester, England"), _c('br'), _c('i', [_vm._v("1 and 2 Kings")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTOPHER")]), _vm._v(" M. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UCKETT")]), _c('br'), _vm._v("Professor of New Testament Studies"), _c('br'), _vm._v("University of Oxford"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("Introduction to the Gospels")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" E. V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OORST")]), _c('br'), _vm._v("Professor of New Testament"), _c('br'), _vm._v("Western Theological Seminary"), _c('br'), _vm._v("Holland, Michigan"), _c('br'), _c('i', [_vm._v("New Testament Apocrypha")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARLES")]), _vm._v(" A. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANAMAKER")]), _c('br'), _vm._v("Associate Professor of Religious Studies"), _c('br'), _vm._v("University of Cape Town"), _c('br'), _vm._v("Cape Town, South Africa"), _c('br'), _c('i', [_vm._v("Philippians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDON")]), _vm._v(" J. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENHAM")]), _c('br'), _vm._v("Professor of Old Testament"), _c('br'), _vm._v("University of Gloucestershire"), _c('br'), _vm._v("Gloucestershire, England"), _c('br'), _c('i', [_vm._v("Genesis")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERALD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EST")]), _c('br'), _vm._v("Head of the School of Theology"), _c('br'), _vm._v("Director of the Institute for the Study of the Bible and Worker Ministry"), _c('br'), _vm._v("Project Pietermaritzburg, South Africa"), _c('br'), _c('i', [_vm._v("Ruth")]), _vm._v(" and "), _c('i', [_vm._v("Judith")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGH")]), _vm._v(" G. M. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAMSON")]), _c('br'), _vm._v("Regius Professor of Hebrew"), _c('br'), _vm._v("University of Oxford"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("1 Esdras")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("K. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AWSON")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNGER")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v("."), _c('br'), _vm._v("Professor of Old Testament, Semitic Languages, and Ancient Near Eastern History"), _c('br'), _vm._v("Trinity International University—Divinity School"), _c('br'), _vm._v("Deerfield, Illinois"), _c('br'), _c('i', [_vm._v("Joshua")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eda8bd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contributors.vue
// module id = 69
// module chunks = 0